"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextNMRHint = getNextNMRHint;
const getNMRHints_js_1 = require("./getNMRHints.js");
/**
 *
 * @param {import('openchemlib').Molecule} correct
 * @param {import('openchemlib').Molecule} proposed
 * @param {Array} providedHints
 */
function getNextNMRHint(correct, proposed, providedHints) {
    const hints = (0, getNMRHints_js_1.getNMRHints)(correct, proposed);
    const possibleHints = hints.filter((possibleHint) => !providedHints.some((providedHint) => possibleHint.hash === providedHint.hash));
    if (possibleHints.length === 0)
        return undefined;
    return {
        ...possibleHints[0],
        idCode: proposed.getIDCode(),
    };
}
//# sourceMappingURL=getNextNMRHint.js.map